<script module lang="ts">
	type Icon =
		| 'expand'
		| 'fullscreen'
		| 'canvas'
		| 'grid'
		| 'minimize'
		| 'masonry'
		| 'vertical'
		| 'horizontal'
		| 'plus'
		| 'close'
		| 'zoom-out'
		| 'zoom-in'
		| 'look-up'
		| 'open-panel'
		| 'close-panel'
		| 'light-table'
		| 'exit-fullscreen'
		| 'minus'
		| 'trash';
	export interface RFInspectorControlProps {
		onclick?: (e: MouseEvent) => void;
		icon: Icon;
		ariaLabel?: string;
		ariaHaspopup?: 'dialog' | 'menu' | 'grid' | 'listbox' | 'tree' | undefined;
		ariaControls?: string;
		active?: boolean;
		style?: string;
	}
</script>

<script lang="ts">
	import Expand from '@core/elements/icons/expand.svelte';
	import ZoomOut from '@core/elements/icons/zoom-out.svelte';
	import ZoomIn from '@core/elements/icons/zoom-in.svelte';
	import Fullscreen from '@core/elements/icons/fullscreen.svelte';
	import LookUp from '@core/elements/icons/look-up.svelte';
	import OpenPanel from '@core/elements/icons/close-panel.svelte';
	import ClosePanel from '@core/elements/icons/open-panel.svelte';
	import Canvas from '@core/elements/icons/canvas.svelte';
	import Grid from '@core/elements/icons/grid.svelte';
	import LightTable from '@core/elements/icons/light-table.svelte';
	import Minimize from '@core/elements/icons/minimize.svelte';
	import Masonry from '@core/elements/icons/masonry.svelte';
	import Vertical from '@core/elements/icons/vertical.svelte';
	import Horizontal from '@core/elements/icons/horizontal.svelte';
	import Plus from '@core/elements/icons/plus.svelte';
	import Close from '@core/elements/icons/close.svelte';
	import ExitFullscreen from '@core/elements/icons/exit-fullscreen.svelte';
	import Minus from '@core/elements/icons/minus.svelte';
	import Trash from '@core/elements/icons/trash.svelte';
	import classNames from 'classnames';

	let { onclick = () => {}, icon, ariaLabel, ariaHaspopup, ariaControls, active, style }: RFInspectorControlProps = $props();

	const IconElement = {
		expand: Expand,
		fullscreen: Fullscreen,
		canvas: Canvas,
		grid: Grid,
		minimize: Minimize,
		masonry: Masonry,
		vertical: Vertical,
		horizontal: Horizontal,
		plus: Plus,
		close: Close,
		'zoom-out': ZoomOut,
		'zoom-in': ZoomIn,
		'look-up': LookUp,
		'open-panel': OpenPanel,
		'close-panel': ClosePanel,
		'light-table': LightTable,
		'exit-fullscreen': ExitFullscreen,
		minus: Minus,
		trash: Trash,
	};

	const IconComponent = $derived(IconElement[icon as Icon]);
</script>

<button
	class={classNames('rf-inspector-control', { 'rf-inspector-control--active': active })}
	{onclick}
	title={ariaLabel}
	aria-label={ariaLabel}
	aria-haspopup={ariaHaspopup}
	aria-controls={ariaControls}
	part="rf-inspector-control"
	{style}
>
	<IconComponent />
</button>

<style lang="scss" global>
	.rf-inspector-control {
		background-color: var(--rf-inspector-control-bg-color, rgb(35, 35, 35));
		width: var(--rf-inspector-control-width, 40px);
		height: var(--rf-inspector-control-height, 40px);

		border: solid var(--rf-inspector-control-border-color, rgb(50, 50, 50)) 1px;
		border-radius: var(--rf-inspector-control-border-radius, 8px);

		color: var(--rf-inspector-control-color, #fff);
		backdrop-filter: blur(4px);

		transition: 0.3s ease background;
		cursor: pointer;
		display: flex;
		gap: var(--rf-spacing-xs, 4px);
		flex-direction: column;
		justify-content: center;
		align-items: center;
		z-index: 1;

		&--active {
			background-color: var(--rf-inspector-control-active-color, rgba(255, 255, 255, 0.2));
		}

		&:hover {
			background-color: var(--rf-inspector-control-hover-color, rgba(255, 255, 255, 0.5));
		}
		svg {
			flex-grow: 0;
			flex-shrink: 0;
			width: 16px;
		}
	}
</style>
